/*!
 * buffer-map.js - buffer map for javascript
 * Copyright (c) 2018, Christopher Jeffrey (MIT License).
 * https://github.com/chjj/buffer-map
 */

/* global SharedArrayBuffer */
'use strict';

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _require = require('./custom'),
    custom = _require.custom;
/**
 * Buffer Map
 */


var BufferMap = /*#__PURE__*/function () {
  function BufferMap(iterable) {
    _classCallCheck(this, BufferMap);

    this.map = new Map();

    if (iterable != null) {
      var _iterator = _createForOfIteratorHelper(iterable),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];

          this.set(key, value);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }

  _createClass(BufferMap, [{
    key: "get",
    value: function get(key) {
      var item = this.map.get(toBinary(key));
      if (!item) return undefined;
      return item.value;
    }
  }, {
    key: "has",
    value: function has(key) {
      return this.map.has(toBinary(key));
    }
  }, {
    key: "set",
    value: function set(key, value) {
      this.map.set(toBinary(key), new BufferItem(key, value));
      return this;
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      return this.map.delete(toBinary(key));
    }
  }, {
    key: "clear",
    value: function clear() {
      this.map.clear();
    }
  }, {
    key: Symbol.iterator,
    value: function value() {
      return this.entries();
    }
  }, {
    key: "entries",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function entries() {
      var _iterator2, _step2, _step2$value, key, value;

      return _regeneratorRuntime.wrap(function entries$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iterator2 = _createForOfIteratorHelper(this.map.values());
              _context.prev = 1;

              _iterator2.s();

            case 3:
              if ((_step2 = _iterator2.n()).done) {
                _context.next = 9;
                break;
              }

              _step2$value = _step2.value, key = _step2$value.key, value = _step2$value.value;
              _context.next = 7;
              return [key, value];

            case 7:
              _context.next = 3;
              break;

            case 9:
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](1);

              _iterator2.e(_context.t0);

            case 14:
              _context.prev = 14;

              _iterator2.f();

              return _context.finish(14);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, entries, this, [[1, 11, 14, 17]]);
    })
  }, {
    key: "keys",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function keys() {
      var _iterator3, _step3, key;

      return _regeneratorRuntime.wrap(function keys$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _iterator3 = _createForOfIteratorHelper(this.map.values());
              _context2.prev = 1;

              _iterator3.s();

            case 3:
              if ((_step3 = _iterator3.n()).done) {
                _context2.next = 9;
                break;
              }

              key = _step3.value.key;
              _context2.next = 7;
              return key;

            case 7:
              _context2.next = 3;
              break;

            case 9:
              _context2.next = 14;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](1);

              _iterator3.e(_context2.t0);

            case 14:
              _context2.prev = 14;

              _iterator3.f();

              return _context2.finish(14);

            case 17:
            case "end":
              return _context2.stop();
          }
        }
      }, keys, this, [[1, 11, 14, 17]]);
    })
  }, {
    key: "values",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function values() {
      var _iterator4, _step4, value;

      return _regeneratorRuntime.wrap(function values$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _iterator4 = _createForOfIteratorHelper(this.map.values());
              _context3.prev = 1;

              _iterator4.s();

            case 3:
              if ((_step4 = _iterator4.n()).done) {
                _context3.next = 9;
                break;
              }

              value = _step4.value.value;
              _context3.next = 7;
              return value;

            case 7:
              _context3.next = 3;
              break;

            case 9:
              _context3.next = 14;
              break;

            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](1);

              _iterator4.e(_context3.t0);

            case 14:
              _context3.prev = 14;

              _iterator4.f();

              return _context3.finish(14);

            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, values, this, [[1, 11, 14, 17]]);
    })
  }, {
    key: "forEach",
    value: function forEach(func, self) {
      if (typeof func !== 'function') throw new TypeError("".concat(typeof func, " is not a function"));

      var _iterator5 = _createForOfIteratorHelper(this.map.values()),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _step5$value = _step5.value,
              key = _step5$value.key,
              value = _step5$value.value;
          func.call(self, value, key, this);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  }, {
    key: "toKeys",
    value: function toKeys() {
      var out = [];

      var _iterator6 = _createForOfIteratorHelper(this.map.values()),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var key = _step6.value.key;
          out.push(key);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      return out;
    }
  }, {
    key: "toValues",
    value: function toValues() {
      var out = [];

      var _iterator7 = _createForOfIteratorHelper(this.map.values()),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var value = _step7.value.value;
          out.push(value);
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      return out;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      return this.toValues();
    }
  }, {
    key: custom,
    value: function value() {
      var map = new Map();

      var _iterator8 = _createForOfIteratorHelper(this.map.values()),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var _step8$value = _step8.value,
              key = _step8$value.key,
              value = _step8$value.value;
          map.set(toHex(key), value);
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }

      return map;
    }
  }, {
    key: "size",
    get: function get() {
      return this.map.size;
    }
  }]);

  return BufferMap;
}();
/**
 * Buffer Set
 */


var BufferSet = /*#__PURE__*/function () {
  function BufferSet(iterable) {
    _classCallCheck(this, BufferSet);

    this.map = new Map();

    if (iterable != null) {
      var _iterator9 = _createForOfIteratorHelper(iterable),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var key = _step9.value;
          this.add(key);
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
    }
  }

  _createClass(BufferSet, [{
    key: "has",
    value: function has(key) {
      return this.map.has(toBinary(key));
    }
  }, {
    key: "add",
    value: function add(key) {
      this.map.set(toBinary(key), key);
      return this;
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      return this.map.delete(toBinary(key));
    }
  }, {
    key: "clear",
    value: function clear() {
      this.map.clear();
    }
  }, {
    key: Symbol.iterator,
    value: function value() {
      return this.keys();
    }
  }, {
    key: "entries",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function entries() {
      var _iterator10, _step10, key;

      return _regeneratorRuntime.wrap(function entries$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _iterator10 = _createForOfIteratorHelper(this.map.values());
              _context4.prev = 1;

              _iterator10.s();

            case 3:
              if ((_step10 = _iterator10.n()).done) {
                _context4.next = 9;
                break;
              }

              key = _step10.value;
              _context4.next = 7;
              return [key, key];

            case 7:
              _context4.next = 3;
              break;

            case 9:
              _context4.next = 14;
              break;

            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4["catch"](1);

              _iterator10.e(_context4.t0);

            case 14:
              _context4.prev = 14;

              _iterator10.f();

              return _context4.finish(14);

            case 17:
            case "end":
              return _context4.stop();
          }
        }
      }, entries, this, [[1, 11, 14, 17]]);
    })
  }, {
    key: "keys",
    value: function keys() {
      return this.map.values();
    }
  }, {
    key: "values",
    value: function values() {
      return this.map.values();
    }
  }, {
    key: "forEach",
    value: function forEach(func, self) {
      if (typeof func !== 'function') throw new TypeError("".concat(typeof func, " is not a function"));

      var _iterator11 = _createForOfIteratorHelper(this.map.values()),
          _step11;

      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var key = _step11.value;
          func.call(self, key, key, this);
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
    }
  }, {
    key: "toKeys",
    value: function toKeys() {
      var out = [];

      var _iterator12 = _createForOfIteratorHelper(this.map.values()),
          _step12;

      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var key = _step12.value;
          out.push(key);
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }

      return out;
    }
  }, {
    key: "toValues",
    value: function toValues() {
      return this.toKeys();
    }
  }, {
    key: "toArray",
    value: function toArray() {
      return this.toKeys();
    }
  }, {
    key: custom,
    value: function value() {
      var set = new Set();

      var _iterator13 = _createForOfIteratorHelper(this.map.values()),
          _step13;

      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var key = _step13.value;
          set.add(toHex(key));
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }

      return set;
    }
  }, {
    key: "size",
    get: function get() {
      return this.map.size;
    }
  }]);

  return BufferSet;
}();
/**
 * Buffer Item
 */


var BufferItem = function BufferItem(key, value) {
  _classCallCheck(this, BufferItem);

  this.key = key;
  this.value = value;
};
/*
 * Helpers
 */


var HAS_SHARED_ARRAY_BUFFER = typeof SharedArrayBuffer === 'function';

function isArrayBuffer(key) {
  if (key instanceof ArrayBuffer) return true;

  if (HAS_SHARED_ARRAY_BUFFER) {
    if (key instanceof SharedArrayBuffer) return true;
  }

  return false;
}

function toBuffer(key) {
  if (ArrayBuffer.isView(key)) return Buffer.from(key.buffer, key.byteOffset, key.byteLength);
  if (isArrayBuffer(key)) return Buffer.from(key, 0, key.byteLength);
  throw new TypeError('Non-buffer passed to buffer map/set.');
}

function encode(key, encoding) {
  if (!Buffer.isBuffer(key)) key = toBuffer(key);
  return key.toString(encoding);
}

function toBinary(key) {
  return encode(key, 'binary');
}

function toHex(key) {
  return encode(key, 'hex');
}
/*
 * Expose
 */


exports.BufferMap = BufferMap;
exports.BufferSet = BufferSet;